exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-stxt-title {\r\n    height: auto;\r\n    border-bottom: 1px dotted #ddd;\r\n    padding: 3px 0;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    white-space: normal;\r\n    font-size: 8.5pt;\r\n    min-width: 223px;\r\n    text-overflow: ellipsis;\r\n    line-height: 1.2;\r\n    font-weight: 600;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/Parent-Portal/parentnavbar/parentnavbar.component.css
// module id = 1105
// module chunks = 322